
export const govBr = (state: string[] = [], action: any): string[] => {
	switch (action.type) {
		case 'GovBr.Report':
			return [
				...action.report
			]
		default:
			return state
	}
}



// WEBPACK FOOTER //
// ./src/reducers/govBr.ts